import Dialog from "@mui/material/Dialog";
import * as React from "react";
import {EMPTY_FUNC} from "@/helper/method";

type ProviderContext = readonly [(option: TipBoxOption) => void, () => void];

const TipBoxContext = React.createContext<ProviderContext>([
    EMPTY_FUNC,
    EMPTY_FUNC,
]);

export const useTipBox = () => React.useContext(TipBoxContext);

type TipBoxProps = {
    children: React.ReactNode;
    open: boolean;
    onClose?: () => void;
};
type TipBoxOption = Omit<TipBoxProps, "open">;

function TipBoxContainer(props: TipBoxProps) {
    const {children, open, onClose} = props;
    return (
        <Dialog open={open} onClose={onClose}>
            {children}
        </Dialog>
    );
}

export default function TipBox({children}: { children: React.ReactNode }) {
    const [tipBoxs, setTipBoxs] = React.useState<TipBoxProps[]>([]);
    const createTipBox = (option: TipBoxOption) => {
        const tipBox = {...option, open: true};
        setTipBoxs((tipBoxs) => [...tipBoxs, tipBox]);
    };
    const closeTipBox = () => {
        setTipBoxs((tipBoxs) => {
            const latestTipBox = tipBoxs.pop();
            if (!latestTipBox) return tipBoxs;
            if (latestTipBox.onClose) latestTipBox.onClose();
            return [...tipBoxs].concat({...latestTipBox, open: false});
        });
    };
    const contextValue = React.useRef([createTipBox, closeTipBox] as const);

    return (
        <TipBoxContext.Provider value={contextValue.current}>
            {children}
            {tipBoxs.map((tipBox, i) => {
                const {...tipBoxParams} = tipBox;
                return (
                    <TipBoxContainer key={i}  {...tipBoxParams} onClose={closeTipBox}/>
                );
            })}
        </TipBoxContext.Provider>
    );
}